/**
 * Lo que un mensaje del usuario llevó: «1 imagen» / «N imágenes» y la marca
 * «Nota de voz · m:ss». La transcripción es el `content` del mensaje, que
 * dibuja quien llama; acá no hay imagen ni reproductor.
 */
import { Image as ImageIcon, Mic } from 'lucide-react';

import { NUM_MONO_MICRO } from '@/features/chat/components/composer/numero';
import { esCitacionesDeUsuario, type ChatMessage } from '@/services/ragChatService';

import { duracionCorta, etiquetaDeImagenes } from '../lib/adjuntos';

export function datosDeAdjuntos(citations: ChatMessage['citations']) {
  if (!esCitacionesDeUsuario(citations)) return { imagenes: 0, audioMs: null as number | null };
  return {
    imagenes: citations.imagenes?.cantidad ?? 0,
    audioMs: citations.audio ? citations.audio.duration_ms : null,
  };
}

export function MarcasDeAdjuntos({
  citations,
  conAudio = true,
}: {
  citations: ChatMessage['citations'];
  conAudio?: boolean;
}) {
  const { imagenes, audioMs } = datosDeAdjuntos(citations);
  const hayAudio = conAudio && audioMs !== null;
  if (imagenes === 0 && !hayAudio) return null;
  return (
    <div className="text-muted-foreground flex flex-wrap items-center gap-x-3 gap-y-0.5 text-micro">
      {hayAudio && (
        <span className="inline-flex items-center gap-1">
          <Mic className="size-3" aria-hidden />
          Nota de voz · <span className={NUM_MONO_MICRO}>{duracionCorta(audioMs)}</span>
        </span>
      )}
      {imagenes > 0 && (
        <span className="inline-flex items-center gap-1">
          <ImageIcon className="size-3" aria-hidden />
          {etiquetaDeImagenes(imagenes)}
        </span>
      )}
    </div>
  );
}
